import useOnClickOutside from 'use-onclickoutside'

const hasClass = (element, className) =>
  element && (element.correspondingElement ? element.correspondingElement : element).classList.contains(className)

const ignored = (element, ignoredClass) => {
  if (!element) {
    return false
  }

  if (hasClass(element, ignoredClass)) {
    return true
  }

  return ignored(element.parentElement, ignoredClass)
}

export default (ref, handler, ignoredClass = 'navbarBurger') =>
  useOnClickOutside(ref, (event) => {
    if (ignored(event.target, ignoredClass)) {
      return
    }

    handler(event)
  })
